import type { DemandSignalType } from "@/features/demand-signal/api"

type DemandSignalEvent = "demand_signal_view" | "demand_signal_click" | "demand_signal_submit"

/**
 * 수요 조사 전환 측정(B2C-472).
 *
 * 제출 건수만 보면 "20곳에 노출해 5건" 과 "2곳에 노출해 5건" 을 구분할 수 없다.
 * 노출·클릭·제출 세 단계를 모두 보내야 전환율이 나온다.
 */
export const pushDemandSignalEvent = (
  event: DemandSignalEvent,
  hospitalOriginId: number,
  signalType?: DemandSignalType,
) => {
  if (typeof window === "undefined") return
  const layer = (window as unknown as { dataLayer?: unknown[] }).dataLayer
  if (!Array.isArray(layer)) return
  layer.push({ event, hospital_origin_id: hospitalOriginId, signal_type: signalType })
}
